var map = {
	"./Dashboard.vue": [
		"0a6e",
		"chunk-d8763076",
		"chunk-6fc01cc4"
	],
	"./ManageLecturer.vue": [
		"da14",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-cce6d4f0",
		"chunk-3169e46b",
		"chunk-90fc8364",
		"chunk-db397138",
		"chunk-7fdbb28e"
	],
	"./ManageMajor.vue": [
		"3d72",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-fa73787e",
		"chunk-7ae2e164",
		"chunk-44fb04db",
		"chunk-2d184844",
		"chunk-2d19e48e"
	],
	"./ManagePermission.vue": [
		"0523",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-73221c10",
		"chunk-7ae2e164",
		"chunk-44fb04db",
		"chunk-2d184844",
		"chunk-326fee48"
	],
	"./ManageRole.vue": [
		"7519",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-11923a51",
		"chunk-a97b1978",
		"chunk-3005afd2",
		"chunk-65e4d47a",
		"chunk-515d8a3e"
	],
	"./ManageStudent.vue": [
		"fc86",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-7ae744eb",
		"chunk-5f9eafb1",
		"chunk-1ecf5a08",
		"chunk-45e48838",
		"chunk-2a4a6160"
	],
	"./ManageUser.vue": [
		"f244",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-6568c3d4",
		"chunk-516b2f77",
		"chunk-74aefea6",
		"chunk-2d184844",
		"chunk-045924ea"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2498";
module.exports = webpackAsyncContext;